module.exports = __webpack_public_path__ + "static/media/body-left.c3c55a60.png";